export default function CoupleBio() {
  return (
    <section id="couple-bio" className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <div className="w-16 h-px bg-gray-800 mx-auto mb-6"></div>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-gray-900 mb-4">Our Story</h2>
          <p className="text-gray-600 text-sm sm:text-base font-light tracking-wide">
            A love story written in the stars
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 sm:gap-12 max-w-6xl mx-auto mb-12 sm:mb-16">
          <div className="text-center">
            <div className="w-48 h-64 sm:w-64 sm:h-80 mb-6 overflow-hidden mx-auto">
              <img
                src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/ffe3e869ccf4a2420881d9c24e526761.jpeg"
                alt="William Evan Thieme"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-3">William Evan Thieme</h3>
            <p className="text-gray-600 text-sm font-light tracking-wide leading-relaxed px-4">
              William is a successful roofing business owner with a passion for quality craftsmanship and customer satisfaction. Born and raised in Liberty, Missouri, he built his company from the ground up and takes pride in protecting families' homes. When he's not running his business, you'll find him mountain biking through scenic trails or spending quality time with his kids, creating memories that will last a lifetime.
            </p>
          </div>

          <div className="text-center">
            <div className="w-48 h-64 sm:w-64 sm:h-80 mb-6 overflow-hidden mx-auto">
              <img
                src="https://static.readdy.ai/image/cd984ab7ba08a0f8b6f75adc7751930e/508cae4ea6e0ada6a5e4eea4a94e2954.jpeg"
                alt="Mary Elizabeth Hilton"
                className="w-full h-full object-cover object-[center_20%]"
              />
            </div>
            <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-3">Mary Elizabeth Hilton</h3>
            <p className="text-gray-600 text-sm font-light tracking-wide leading-relaxed px-4">
              Mary is an amazing massage therapist with a healing touch and compassionate spirit. As a devoted homemaker and mother, she creates a warm, nurturing environment where her family thrives. When she's not caring for others, Mary loves spending time on the water boating, exploring mountain trails while hiking, and carving down snowy slopes skiing with her loved ones.
            </p>
          </div>
        </div>

        <div className="max-w-4xl mx-auto bg-gray-50 p-8 sm:p-12">
          <div className="text-center mb-6 sm:mb-8">
            <i className="ri-heart-3-line text-4xl sm:text-5xl text-gray-800 mb-4"></i>
            <h3 className="font-serif text-2xl sm:text-3xl text-gray-900 mb-6">How We Met</h3>
          </div>
          <p className="text-gray-700 text-sm sm:text-base font-light tracking-wide leading-relaxed mb-4 sm:mb-6 text-center px-4">
            Our love story began on a beautiful early evening at a local cidery in the December of 2021. Mary had just arrived and was struggling to parallel park in a tight spot. Watching from nearby, William couldn't help but notice her determination—and decided to offer his assistance.
          </p>
          <p className="text-gray-700 text-sm sm:text-base font-light tracking-wide leading-relaxed mb-4 sm:mb-6 text-center px-4">
            With a warm smile and a bit of charm, William helped Mary navigate into the perfect parking spot. What started as a simple act of kindness turned into hours of conversation over craft ciders, laughter, and an undeniable connection that neither of them could ignore.
          </p>
          <p className="text-gray-700 text-sm sm:text-base font-light tracking-wide leading-relaxed text-center px-4">
            From that moment on, William swept Mary off her feet. Their cidery meeting blossomed into countless adventures, shared dreams, and a love that grew stronger with each passing day. Now, they're ready to park their hearts together forever.
          </p>
        </div>
      </div>
    </section>
  );
}
